import { clsx } from 'clsx';
import React, { forwardRef } from 'react';
import '@primer/behaviors/utils';
import '@primer/behaviors';
import { useRefObjectAsForwardedRef } from '../hooks/useRefObjectAsForwardedRef.js';
import classes from './Text.module.css.js';
import { toggleSxComponent } from '../internal/utils/toggleSxComponent.js';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const TextBaseComponent = toggleSxComponent('span');
const Text = /*#__PURE__*/forwardRef(({
  as: Component = 'span',
  className,
  size,
  weight,
  ...props
}, forwardedRef) => {
  const innerRef = React.useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/React.createElement(TextBaseComponent, _extends({
    as: Component,
    className: clsx(className, classes.Text),
    "data-size": size,
    "data-weight": weight
  }, props, {
    // @ts-ignore shh
    ref: innerRef
  }));

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
});
Text.displayName = 'Text';

export { Text as default };
